import request from "root/js/request";

export const getProductCostInfo = async ({
  product_cost__isnull = true,
  group_by = "barcode",
  cabinet_id,
  shares_id,
  product_id,
  ...rest
}) => {
  const response = await request({
    url: `analytics/shares_products/cost_info/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    method: "get",
    params: {
      product_cost__isnull,
      group_by,
      product_id,
      ...rest,
    },
  });
  return response.data;
};
